import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import { LayoutDashboardIcon, UserIcon } from 'lucide-react';
import { currentOfficerId, officers } from '../../data/officers';
const navItems = [{
  to: '/',
  label: 'Company overview',
  icon: LayoutDashboardIcon,
  end: true
}, {
  to: '/me',
  label: 'My commissions',
  icon: UserIcon,
  end: false
}];

/** Top-level navigation for the admin experience. */
export function AdminShell() {
  const me = officers.find(officer => officer.id === currentOfficerId) ?? officers[0];
  return <div className="min-h-screen w-full bg-slate-50" data-id="element-16" data-mp="2d7phibkmg7zh">
      <nav aria-label="Admin" className="bg-brand-950 text-white" data-id="element-17" data-mp="1z9909qp4uz33">
        <div className="mx-auto flex h-14 max-w-7xl items-center justify-between gap-4 px-6" data-id="element-18" data-mp="1zb25d1k3lb8z">
          <div className="flex items-center gap-6" data-id="element-19" data-mp="249n8b8qqi914">
            <div className="flex items-center gap-2.5" data-id="element-20" data-mp="nsixkhjx4pe8">
              <span aria-hidden="true" className="flex h-7 w-7 items-center justify-center rounded-md bg-white text-xs font-extrabold text-brand-900" data-id="element-21" data-mp="ssnjwo7icecd">
                N
              </span>
              <span className="hidden text-sm font-bold sm:inline" data-id="element-22" data-mp="2vvgp9yp0vlp6">Northbridge Commissions</span>
              <span className="rounded-full bg-gold-400/20 px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider text-gold-300" data-id="element-23" data-mp="3aspjd05pn3kl">
                Admin
              </span>
            </div>
            <ul className="flex items-center gap-1" data-id="element-24" data-mp="3jrkoe8x0q7mb">
              {navItems.map(item => <li key={item.to} data-id="element-25" data-mp="3eu1d9hvmaayl">
                  <NavLink to={item.to} end={item.end} className={({
                isActive
              }) => `inline-flex items-center gap-2 rounded-md px-3 py-1.5 text-sm font-semibold transition ${isActive ? 'bg-white/15 text-white' : 'text-brand-200 hover:bg-white/10 hover:text-white'}`} data-id="element-26" data-mp="3esq6d96vkn39">
                    <item.icon className="h-4 w-4" aria-hidden="true" data-id="element-27" data-mp="9f2kktj289kz" />
                    <span className="hidden sm:inline" data-id="element-28" data-mp="9cya1sqnocbq">{item.label}</span>
                  </NavLink>
                </li>)}
            </ul>
          </div>
          <div className="flex items-center gap-2.5" data-id="element-29" data-mp="jcgqw0b9rhzk">
            <span className="hidden text-right text-xs leading-tight md:block" data-id="element-30" data-mp="o3yt0rp13om4">
              <span className="block font-semibold text-white" data-id="element-31" data-mp="o61p9tgrydza">{me.name}</span>
              <span className="text-brand-300" data-id="element-32" data-mp="s50xpo1pssvh">Commission admin</span>
            </span>
            <span aria-hidden="true" className="flex h-8 w-8 items-center justify-center rounded-full bg-white/15 text-xs font-bold" data-id="element-33" data-mp="x3c75xo3l1d6">
              {me.initials}
            </span>
          </div>
        </div>
      </nav>
      <Outlet data-id="element-34" data-mp="33vmo0hkhf72a" />
    </div>;
}